import { useTranslation } from '@packages/utils';
import { EUserType } from 'data/types/user.types';
import { useAppSelector } from 'redux/store';
import { TEventTypeGroup } from './GroupedEventTypeSelect.types';

/** Roles that grant access to AEYC event types */
const AEYC_ADMIN_ROLES: EUserType[] = [
  EUserType.READY_ADMIN,
  EUserType.SUPER_ADMIN,
  EUserType.ELC_LEAD,
];

/** AEYC event type values */
const AEYC_EVENT_TYPES = ['PARENT_CAFE'] as const;

/** Public event type values (alphabetical per FR-1, with OTHER at the end) */
const PUBLIC_EVENT_TYPES = [
  'BOOK_FAIR',
  'COMMUNITY_EVENT',
  'CONFERENCE_ATTENDANCE',
  'CONFERENCE_HOST',
  'CONFERENCE_PRESENTATION',
  'CONFERENCE_VENDOR_TABLE',
  'EARLY_LEARNING_FAIR',
  'FUNDRAISER',
  'KINDERGARTEN_REGISTRATION',
  'PLC_EVENT',
  'TRAINING',
  'OTHER',
] as const;

const useGroupedEventTypeData = () => {
  const { t } = useTranslation();
  const user = useAppSelector(state => state.userSlice.user);

  const hasAeycAccess =
    user?.type?.some((role: EUserType) => AEYC_ADMIN_ROLES.includes(role)) ??
    false;

  const aeycGroup: TEventTypeGroup = {
    label: 'AEYC Events',
    options: AEYC_EVENT_TYPES.map(value => ({
      value,
      label: t(`enums.event-type.${value}`),
    })),
  };

  const publicGroup: TEventTypeGroup = {
    label: 'Public Events',
    options: PUBLIC_EVENT_TYPES.map(value => ({
      value,
      label: t(`enums.event-type.${value}`),
    })),
  };

  const groups: TEventTypeGroup[] = [
    ...(hasAeycAccess ? [aeycGroup] : []),
    publicGroup,
  ];

  return { groups };
};

export default useGroupedEventTypeData;
